import React from 'react';
import { Link } from 'react-router-dom';
import { ICON_TABLE } from '../extras/icons';
//Función Principal
const LinkCard = props => {
    const { title, subtitle, link, icon, color } = props;
    //Renderizar
    return (
        <div className="col-xl-3 col-md-6 mb-4">
            <Link to={link} className={`card border-left-${color} shadow h-100 py-2`}>
                <div className="card-body">
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                            <div className={`text-xs font-weight-bold text-${color} text-uppercase mb-1`}>
                                { subtitle }
                            </div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">
                                { title }
                            </div>
                        </div>
                        <div className="col-auto">
                            <ICON_TABLE className="fa-2x text-gray-300" />
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default LinkCard;